import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BuildingFilled: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 23, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 28) / 23}
      viewBox="0 0 23 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8138 0C14.0426 0.0035 14.268 0.0746669 14.4601 0.211167C14.7671 0.429334 14.95 0.786333 14.95 1.16667V26.8333C14.95 27.4727 14.4429 27.9918 13.8149 28H13.8H1.15C0.5152 28 0 27.4773 0 26.8333C0 26.8333 0 12.4052 0 7.46783C0 5.9955 0.90735 4.68183 2.27125 4.17783C5.62925 2.94 13.4067 0.0699999 13.4067 0.0699999C13.5286 0.0256666 13.6539 0.00233333 13.7793 0H13.7965H13.8138ZM17.25 9.56433L20.9093 11.1545C22.1777 11.7063 23 12.9722 23 14.3722V26.8333C23 27.4773 22.4848 28 21.85 28H17.0534C17.181 27.6348 17.25 27.2428 17.25 26.8333V9.56433ZM9.21495 19.8333C9.84285 19.8252 10.35 19.306 10.35 18.6667C10.35 18.0227 9.8348 17.5 9.2 17.5H5.75C5.1152 17.5 4.6 18.0227 4.6 18.6667C4.6 19.3107 5.1152 19.8333 5.75 19.8333H9.2H9.21495ZM9.21495 15.1667C9.84285 15.1585 10.35 14.6393 10.35 14C10.35 13.356 9.8348 12.8333 9.2 12.8333H5.75C5.1152 12.8333 4.6 13.356 4.6 14C4.6 14.644 5.1152 15.1667 5.75 15.1667H9.2H9.21495ZM9.21495 10.5C9.84285 10.4918 10.35 9.97267 10.35 9.33333C10.35 8.68933 9.8348 8.16667 9.2 8.16667H5.75C5.1152 8.16667 4.6 8.68933 4.6 9.33333C4.6 9.97733 5.1152 10.5 5.75 10.5H9.2H9.21495Z"
        fill="currentColor"
      />
    </svg>
  )
})

BuildingFilled.displayName = 'BuildingFilled'
